// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   InputLabel,
//   MenuItem,
//   Select,
//   Typography,
//   Grid as MuiGrid,
//   Pagination,
//   Grid,
//   IconButton,
// } from '@mui/material';
// import TableCells from 'src/components/Tables/TableCells';
// import { useMain } from '../hooks/useMain';
// import ShowLoader from 'src/components/CustomComponents/ShowLoader';
// import SearchImg from '../../assets/search.svg';
// import DateRangeInputs from 'src/components/inputs/DateRangeInputs';
// import BigFilter from 'src/components/inputs/BigFilter';
// import { ClearIcon } from '@mui/x-date-pickers-pro';
// import { AiOutlineInfoCircle } from "react-icons/ai";
// import { MdDelete } from "react-icons/md";
// import { useNavigate } from 'react-router';

// const filterGenderWise = [
//   { value: 'Female', label: 'Female' },
//   { value: 'Male', label: 'Male' },
// ];

// const packageType = [
//   { value: 'Package', label: 'Package Bills' },
//   { value: 'Membership', label: 'Membership Bills' },
// ];

// export const TrimData = (data) => {
//   if (data?.length < 25) return data;
//   return data?.substring(0, 15) + '...' + data?.substring(data?.length - 10);
// };

// export const maskData = (value, isMasked) => {
//   if (isMasked) {
//     const maskLength = Math.ceil(value.length / 2);
//     return '*'.repeat(maskLength) + value.substring(maskLength);
//   } else {
//     return value;
//   }
// };

// const PackageAllBill = () => {
//   const [packagedata, setPackageData] = useState([]);
//   const [showLoader, setShowLoader] = useState(true);
//   const [search, setSearch] = useState('');
//   const [genderBy, setGenderBy] = useState([]);
//   const [selectedByPackage, setSelectedByPackage] = useState([]);
//   const [limit, setLimit] = useState(10);
//   const [page, setPage] = useState(1);
//   const [clear, setClear] = useState(false);
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [filterData, setFilterData] = useState([]);
//   const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);
//   const [deleteLoading, setDeleteLoading] = useState(false);
//   const [filteredDataCount, setFilteredDataCount] = useState(0);
//   const [packagePageTotals, setPackagePageTotals] = useState({ totalAmount: 0, amountPaid: 0, paidDues: 0 });

//   const navigate = useNavigate()
//   const { activeBranchId, setShowMessage, fetchPackageBills, branchData, deletePackagebill } = useMain();

//   const handleDatails = (id) => {
//     navigate(`/billing/${id}`);
//   };

//   const openModal = () => setIsModalOpen(true);

//   const closeModal = () => {
//     setIsModalOpen(false);
//   };

//   const handleDateRangeSelected = (start, end) => {
//     setStartDate(start);
//     setEndDate(end);
//     setIsModalOpen(false);
//     const queryParams = `?page=${page}${genderBy ? `&gender=${genderBy}` : ''}${search ? `&search=${search}` : ''
//       }${start ? `&startDate=${start}` : ''}${end ? `&endDate=${end}` : ''}`;
//     getPackageBillsData(queryParams);
//     setClear(true);
//   };

//   const clearDataHandler = () => {
//     setLimit(10);
//     setPage(1);
//     setSearch('');
//     setGenderBy('');
//     setEndDate('');
//     setStartDate('');
//     setSelectedByPackage('');
//     getPackageBillsData('?page=1');
//     setClear(false);
//   };

//   const onApplyHandler = () => {
//     const queryParams = `?page=${page}&limit=${limit}${genderBy ? `&gender=${genderBy}` : ''}${search ? `&search=${search}` : ''
//       }${startDate ? `&startDate=${startDate}` : ''}${endDate ? `&endDate=${endDate}` : ''}`;
//     getPackageBillsData(queryParams);
//     setClear(true);
//   };

//   useEffect(() => {
//     if (activeBranchId) {
//       const queryParams = `?page=1`;
//       getPackageBillsData(queryParams);
//       setClear(true);
//     }
//     return () => {
//       setPackageData([]);
//     };
//   }, [activeBranchId]);

//   useEffect(() => {
//     applyFilters(packagedata, limit, selectedByPackage, genderBy, page, search, startDate, endDate);
//   }, [packagedata, limit, genderBy, page, search, startDate, endDate]);

//   useEffect(() => {
//     const totals = calculatePageTotals(filterData);
//     setPackagePageTotals(totals);
//   }, [filterData]);

//   const calculatePageTotals = (currentPageData) => {
//     const totalAmount = currentPageData.reduce((acc, item) => acc + (item.amountPayable || 0), 0);

//     const amountPaid = currentPageData.reduce((acc, item) => {
//       if (Array.isArray(item.amountPaid)) {
//         const totalPaid = item.amountPaid.reduce((sum, payment) => sum + (parseFloat(payment.amount) || 0), 0);
//         return acc + totalPaid;
//       }
//       return acc;
//     }, 0);

//     const paidDues = currentPageData.reduce((acc, item) => acc + (item.paidDues || 0), 0);

//     return { totalAmount, amountPaid, paidDues: isNaN(paidDues) ? 0 : paidDues };
//   };

//   const getPackageBillsData = async (queryParams = '') => {
//     try {
//       setShowLoader(true);
//       const params = queryParams || '?page=1';
//       const res = await fetchPackageBills(activeBranchId, params);
//       if (res.statusCode === 200) {
//         setPackageData(res?.data || []);
//         if (!queryParams.includes('startDate') && !queryParams.includes('endDate')) {
//           setFilteredDataCount(res?.data?.length || 0);
//         }
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setShowLoader(false);
//     }
//   };

//   const handleLimitChange = (e) => {
//     setLimit(e.target.value);
//     setPage(1);
//   };

//   const applyFilters = (data, limit, selectedByPackage, gender, page, search, startDate, endDate) => {
//     let filteredData = [...data];

//     filteredData = filteredData.filter((item) => {
//       let isGenderMatch = true;
//       let isNameMatch = true;
//       let isPackageType = true;

//       if (selectedByPackage.length) {
//         isPackageType = selectedByPackage.includes(item.billType);
//       }

//       if (gender.length) {
//         isGenderMatch = genderBy.includes(item.gender);
//       }

//       if (search) {
//         isNameMatch =
//           item.clientName.toLowerCase().includes(search.toLowerCase()) ||
//           item.clientNumber.includes(search);
//       }

//       if (startDate && endDate) {
//         const itemDate = new Date(item.dateOfBilling);
//         const start = new Date(startDate);
//         const end = new Date(endDate);
//         isNameMatch = isNameMatch && itemDate >= start && itemDate <= end;
//       }

//       return isGenderMatch && isNameMatch && isPackageType;
//     });

//     setFilteredDataCount(filteredData.length);

//     const startIndex = (page - 1) * limit;
//     const endIndex = startIndex + limit;
//     const paginatedData = filteredData.slice(startIndex, endIndex);

//     setFilterData(paginatedData);
//   };

//   const handlePageChange = (e, value) => {
//     setPage(value);
//   };

//   const handleDeleteField = (id) => {
//     setDeleteId(id);
//     setOpenDeleteDialog(true);
//   }

//   const confirmDelete = async () => {
//     setDeleteLoading(true);
//     try {
//       const res = await deletePackagebill(deleteId, activeBranchId);
//       if (res?.statusCode === 200) {
//         setShowMessage({
//           message: res.message || 'Bill deleted successfully',
//           messageType: 'success',
//         });

//         setFilterData((prevData) => prevData.filter((item) => item._id !== deleteId));
//       } else {
//         setShowMessage({
//           message: res.message || 'Bill not deleted',
//           messageType: 'error',
//         });
//       }
//     } catch (error) {
//       setShowMessage({
//         message: error.message || 'Something went wrong',
//         messageType: 'error',
//       });
//     } finally {
//       setOpenDeleteDialog(false);
//       setDeleteId(null);
//       setDeleteLoading(false);
//     }
//   };

//   const handleCloseDeleteDialog = () => {
//     setOpenDeleteDialog(false);
//     setDeleteId(null);
//   };
//   console.log(filterData, 'package billss')
//   return (
//     <>
//       <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
//         <div
//           style={{
//             display: 'flex',
//             flexWrap: 'wrap',
//             alignItems: 'center',
//             marginBottom: '1.5rem',
//           }}
//         >
//           {/* Left Side: Show per page and Choose Date */}
//           <div
//             style={{
//               display: 'flex',
//               flexDirection: 'row',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               flex: '1 1 300px',
//             }}
//           >
//             <div style={{ flex: '1 1 150px', maxWidth: '500px' }}>
//               <InputLabel>Show per page</InputLabel>
//               <Select
//                 style={{
//                   borderRadius: '7px',
//                   border: '0.5px solid #6174DD',
//                   padding: '4px 12px',
//                   background: '#FFF',
//                   height: '40px',
//                 }}
//                 value={limit}
//                 onChange={handleLimitChange}
//               >
//                 {[10, 20, 50].map((value) => (
//                   <MenuItem key={value} value={value}>
//                     {value}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </div>

//             <div style={{
//               flex: '1 1 150px', marginLeft: '-16rem',
//               marginTop: '1.9rem'
//             }}>
//               <Button
//                 variant="outlined"
//                 sx={{
//                   color: 'black',
//                   height: '40px',
//                   width: startDate && endDate ? '60%' : '40%',
//                   display: 'flex',
//                   justifyContent: startDate && endDate ? 'space-between' : 'center',
//                   padding: '0 8px',
//                   whiteSpace: 'nowrap',
//                   overflow: 'hidden',
//                   textOverflow: 'ellipsis',
//                 }}
//                 onClick={openModal}
//               >
//                 {startDate && endDate ? (
//                   <>
//                     <span>{`${startDate} to ${endDate}`}</span>
//                     <IconButton
//                       size="small"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         setStartDate('');
//                         setEndDate('');
//                         setPage(1);
//                         getPackageBillsData('?page=1');
//                       }}
//                       sx={{
//                         padding: 0,
//                         '&:hover': {
//                           backgroundColor: 'transparent',
//                         },
//                       }}
//                     >
//                       <ClearIcon style={{ color: '#000', height: '1rem' }} />
//                     </IconButton>
//                   </>
//                 ) : (
//                   'Choose Date'
//                 )}
//               </Button>
//             </div>
//           </div>
//         </div>

//         {/* Right Side: Filters and Search */}
//         <div style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           marginBottom: '1.4rem',
//           marginLeft: '15rem'
//         }}>
//           <div style={{ width: '60%', marginRight: '-4rem', marginTop: '13px' }}>
//             <BigFilter
//               options={[
//                 { title: 'Gender', items: filterGenderWise },
//                 { title: 'Package Type', items: packageType }
//               ]}
//               value={[...genderBy, ...selectedByPackage]}
//               onChange={(selectedValues) => {
//                 setGenderBy(selectedValues.filter(val => filterGenderWise.some(opt => opt.value === val)));
//                 setSelectedByPackage(selectedValues.filter(val => packageType.some(opt => opt.value === val)));
//               }}
//               placeholder="Filters"
//             />
//           </div>

//           <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '8rem' }} onClick={() => document.getElementById('search-input').focus()}>
//             <InputLabel style={{ display: 'flex', flexDirection: 'column' }}>Search</InputLabel>
//             <div className="search-input" style={{ display: 'flex', alignItems: 'center' }}>
//               <img src={SearchImg} alt="search icon" style={{ marginRight: '8px' }} />
//               <input
//                 id="search-input"
//                 type="text"
//                 value={search}
//                 onChange={(e) => setSearch(e.target.value)}
//                 style={{ border: 'none', outline: 'none', flex: 1 }}
//               />
//               {search && (
//                 <IconButton
//                   onClick={() => {
//                     setSearch('');
//                     setClear(false);
//                   }}
//                   style={{ padding: 1 }}
//                 >
//                   <ClearIcon style={{
//                     color: '#000',
//                     marginRight: '-0.2rem', marginTop: '0.1rem',
//                     fontSize: '1.1rem'
//                   }} />
//                 </IconButton>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       {showLoader ? (
//         <ShowLoader />
//       ) : filterData.length > 0 ? (
//         <Box>
//           <MuiGrid container spacing={3}>
//             <MuiGrid item xs={12}>
//               <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
//                 <table className="table-container mt-3">
//                   <thead className="table-thead">
//                     <tr>
//                       {[
//                         'Date of Bill',
//                         'Client Name',
//                         'Contact',
//                         'Gender',
//                         'Total',
//                         'Paid',
//                         'Pending',
//                         'Mode of Payment',
//                         'Bill Type',
//                         'Actions',
//                       ].map((h, index) => (
//                         <th key={index} style={{ width: '100%' }}>
//                           {h}
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody className="table-tbody">
//                     {filterData.map((item) => {
//                       const originalDate = item?.dateOfBilling;

//                       let formattedBillDate = '';
//                       if (originalDate) {
//                         const [year, month, day] = originalDate.split('-');
//                         formattedBillDate = `${day}-${month}-${year}`;
//                       }

//                       const isDueBill = item.createdBillFor === 'Due';
//                       return (
//                         <tr key={item._id}>
//                           <td style={{ width: '100%' }}>{formattedBillDate}</td>
//                           <td style={{ width: '100%' }}>{item?.clientName}</td>
//                           <td style={{ width: '100%' }}>
//                             {maskData(item?.clientNumber, branchData?.isMasked)}
//                           </td>
//                           <td style={{ width: '100%' }}>{item?.gender}</td>
//                           <td style={{ width: '100%' }}>{item?.amountPayable}</td>
//                           <td style={{ width: '100%' }}>
//                             {item?.amountPaid?.reduce(
//                               (acc, payment) => acc + (Number(payment.amount) || 0),
//                               0,
//                             )}
//                           </td>
//                           <td style={{ width: '100%' }}>{item?.paidDues || "0"}</td>
//                           <td style={{ width: '100%' }}>
//                             {item?.amountPaid?.map(({ paymentType }) => paymentType).join(',  ')}
//                           </td>
//                           <td style={{ width: '100%' }}>{item?.billType}</td>
//                           <td style={{ width: '100%', textAlign: 'left', paddingLeft: '8px' }}>
//                             {isDueBill ? (
//                               <span style={{ fontWeight: 'bold', color: '#ff4d4d' }}>Due Bill</span>
//                             ) : (
//                               <>
//                                 <IconButton
//                                   onClick={() => handleDatails(item._id)}
//                                   color="primary"
//                                   title="View Details"
//                                   style={{ padding: '4px' }}
//                                 >
//                                   <AiOutlineInfoCircle
//                                     style={{ color: '#696969', fontSize: '1.1rem' }}
//                                   />
//                                 </IconButton>

//                                 <IconButton
//                                   onClick={() => handleDeleteField(item._id)}
//                                   color="error"
//                                   title="Delete"
//                                   style={{ padding: '4px' }}
//                                 >
//                                   <MdDelete
//                                     color="#FF4D4D"
//                                     style={{ fontSize: '1.2rem' }}
//                                   />
//                                 </IconButton>
//                               </>
//                             )}
//                           </td>

//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </table>
//                 <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
//                   <DialogContent>
//                     Are you sure you want to delete this Bill?
//                   </DialogContent>
//                   <DialogActions>
//                     <Button onClick={handleCloseDeleteDialog} color="primary">Cancel</Button>
//                     <Button onClick={confirmDelete} color="secondary">Delete</Button>
//                   </DialogActions>
//                 </Dialog>
//               </Box>
//             </MuiGrid>
//           </MuiGrid>
//         </Box>
//       ) : (
//         'No data found'
//       )}

//       <Box display="flex" justifyContent="flex-end">
//         <Pagination
//           count={Math.ceil(filteredDataCount / limit) || 1}
//           page={page}
//           color="primary"
//           onChange={handlePageChange}
//           sx={{
//             '& .MuiPaginationItem-root': {
//               borderRadius: '4px',
//             },
//             '& .Mui-selected': {
//               backgroundColor: '#6174DD',
//               color: '#fff',
//               '&:hover': {
//                 backgroundColor: '#4a5bc7',
//               },
//             },
//           }}
//         />
//       </Box>

//       <Box
//         display="flex"
//         flexDirection="column"
//         style={{
//           width: '100%',
//           marginLeft: '0.5rem',
//           marginTop: '1rem',
//           padding: '1rem',
//           boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
//           borderRadius: '8px'
//         }}
//       >
//         <Typography variant="h6" fontWeight="600" gutterBottom>
//           Amount as per Page
//         </Typography>

//         <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
//           <Typography variant="subtitle1" fontWeight="600">
//             <strong>Total Amount:</strong> ₹ {packagePageTotals.totalAmount}
//           </Typography>
//           <Typography variant="subtitle1" fontWeight="600">
//             <strong>Total Paid:</strong> ₹ {packagePageTotals.amountPaid}
//           </Typography>
//           <Typography variant="subtitle1" fontWeight="600">
//             <strong>Total Pending:</strong> ₹ {packagePageTotals.paidDues}
//           </Typography>
//         </Box>
//       </Box>

//       <DateRangeInputs
//         isOpen={isModalOpen}
//         onClose={closeModal}
//         onDateRangeSelected={handleDateRangeSelected}
//         selectedEndDate={endDate}
//         selectedStartDate={startDate}
//       />
//     </>
//   );
// };

// export default PackageAllBill;

import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Grid as MuiGrid,
  Pagination,
  Grid,
  IconButton,
} from '@mui/material';
import TableCells from 'src/components/Tables/TableCells';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import SearchImg from '../../assets/search.svg';
import DateRangeInputs from 'src/components/inputs/DateRangeInputs';
import BigFilter from 'src/components/inputs/BigFilter';
import { ClearIcon } from '@mui/x-date-pickers-pro';
import { AiOutlineInfoCircle } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { useNavigate } from 'react-router';
import { FaDownload, FaFilePdf, FaFileExcel , FaRegEdit  } from "react-icons/fa";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { Autocomplete, TextField } from '@mui/material';

const filterGenderWise = [
  { value: 'Female', label: 'Female' },
  { value: 'Male', label: 'Male' },
];

const packageType = [
  { value: 'Package', label: 'Package Bills' },
  { value: 'Membership', label: 'Membership Bills' },
];

export const TrimData = (data) => {
  if (data?.length < 25) return data;
  return data?.substring(0, 15) + '...' + data?.substring(data?.length - 10);
};

export const maskData = (value, isMasked) => {
  if (isMasked) {
    const maskLength = Math.ceil(value.length / 2);
    return '*'.repeat(maskLength) + value.substring(maskLength);
  } else {
    return value;
  }
};

const PackageAllBill = () => {
  const [packagedata, setPackageData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [search, setSearch] = useState('');
  const [genderBy, setGenderBy] = useState([]);
  const [selectedByPackage, setSelectedByPackage] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [clear, setClear] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterData, setFilterData] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [filteredDataCount, setFilteredDataCount] = useState(0);
  const [packagePageTotals, setPackagePageTotals] = useState({ totalAmount: 0, amountPaid: 0, paidDues: 0 });
  const [memberships,setMemberships] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedMemberships, setSelectedMemberships] = useState([]);
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [checkedClients, setCheckedClients] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [hideDownloadButton, setHideDownloadButton] = useState(true);
  // ---------- update bill popup ----------
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  const [selectedBill, setSelectedBill] = useState(null);
  const [updateFormData, setUpdateFormData] = useState({});
  const [updateLoading, setUpdateLoading] = useState(false);
  const [serviceProviders, setServiceProviders] = useState([]);

  const originalPaidTotal = (selectedBill?.amountPaid || []).reduce(
    (acc, p) => acc + (Number(p.amount) || 0),
    0,
  );
  const formPaidTotal = (updateFormData?.amountPaid || []).reduce(
    (acc, p) => acc + (Number(p.amount) || 0),
    0,
  );
  const isPaidTotalMatching = Math.abs(formPaidTotal - originalPaidTotal) < 0.01;

  const handleOpenUpdate = (item) => {
    setSelectedBill(item);
    setUpdateFormData({
      dateOfBilling: item.dateOfBilling,
      timeOfBilling: item.timeOfBilling,
      reasonForUpdate: item.reasonForUpdate || '',       
      amountPaid: (item.amountPaid || []).map(({ _id, paymentType, amount }) => ({
        _id,
        paymentType,
        amount,
      })),
    });
    setOpenUpdateDialog(true);
  };

  const handleCloseUpdate = () => {
    setOpenUpdateDialog(false);
    setSelectedBill(null);
    setUpdateFormData({});
  };

  const handleUpdateInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePaymentChange = (e, index) => {
    const { name, value } = e.target;
    setUpdateFormData((prev) => ({
      ...prev,
      amountPaid: prev.amountPaid.map((p, i) => (i === index ? { ...p, [name]: value } : p)),
    }));
  };

  const addPaymentRow = () => {
    setUpdateFormData((prev) => ({
      ...prev,
      amountPaid: [...prev.amountPaid, { paymentType: 'Cash', amount: '' }],
    }));
  };

  // only newly added rows (no _id) can be removed
  const deletePaymentRow = (index) => {
    setUpdateFormData((prev) => ({
      ...prev,
      amountPaid: prev.amountPaid.filter((_, i) => i !== index),
    }));
  };

  const handleUpdateBill = async () => {
    const rows = updateFormData?.amountPaid || [];

    if (rows.some((p) => !p.paymentType || p.amount === '' || isNaN(Number(p.amount)))) {
      setShowMessage({ message: 'Please fill all payment amounts', messageType: 'error' });
      return;
    }
    if (rows.some((p) => !p._id && Number(p.amount) <= 0)) {
      setShowMessage({ message: 'New payment modes need an amount greater than 0', messageType: 'error' });
      return;
    }
    if (!isPaidTotalMatching) {
      setShowMessage({
        message: `Total of payment modes must be ₹${originalPaidTotal}`,
        messageType: 'error',
      });
      return;
    }

    setUpdateLoading(true);
    try {
      const payload = {
        dateOfBilling: updateFormData.dateOfBilling,
        timeOfBilling: updateFormData.timeOfBilling,
        reasonForUpdate: updateFormData.reasonForUpdate,   
        amountPaid: rows.map((p) => ({
          ...(p._id && { _id: p._id }),
          paymentType: p.paymentType,
          amount: Number(p.amount),
        })),
      };

      const updateApi =
        selectedBill.billType === 'Package' ? updatePackageBill : updateMembershipBill;

      const res = await updateApi(selectedBill._id, activeBranchId, payload);

      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Bill updated successfully',
          messageType: 'success',
        });
        handleCloseUpdate();
        // refetch (client-side filters re-apply automatically)
        getPackageBillsData(
          startDate && endDate ? `?page=1&startDate=${startDate}&endDate=${endDate}` : '?page=1',
        );
      } else {
        setShowMessage({ message: res?.message || 'Bill not updated', messageType: 'error' });
      }
    } catch (error) {
      setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
    } finally {
      setUpdateLoading(false);
    }
  };
  const {
    activeBranchId,
    setShowMessage,
    fetchPackageBills,
    branchData,
    deletePackagebill,
    fetchAllMemberships,
    fetchAllPackages,
    getBranch,
    updateMembershipBill,
    updatePackageBill,  
    getAllStaff,
  } = useMain();
useEffect(() => {
  if (!activeBranchId) return;
  const fetchHideDownload = async () => {
    try {
      const res = await getBranch(activeBranchId);
      setHideDownloadButton(res?.data?.hideDownloadButton || false);
    } catch (error) {
      console.error("Error fetching branch data:", error);
    }
  };
  fetchHideDownload();
}, [activeBranchId]);
  useEffect(() => {
  if (branchData) {
    setHideDownloadButton(branchData.hideDownloadButton || false);
  }
}, [branchData]);

useEffect(() => {
  if (!activeBranchId) return;
  const fetchServiceProviders = async () => {
    try {
      const response = await getAllStaff(activeBranchId);
      if (response?.data) setServiceProviders(response.data);
    } catch (error) {
      console.error('Error fetching service providers:', error);
    }
  };
  fetchServiceProviders();
}, [activeBranchId]);

// turn stored provider ids into staff objects for the disabled Autocomplete
const toProviderObjects = (providers) =>
  (Array.isArray(providers) ? providers : [providers])
    .filter(Boolean)
    .map((p) => serviceProviders.find((s) => s._id === (p?._id || p)))
    .filter(Boolean);

// rows shown in the "Service / Products / Packages" table
const billItems = selectedBill
  ? [
      ...(selectedBill.memberships || []).map((m) => ({
        name: m.membershipName,
        providers: toProviderObjects(m.serviceProvider),
        quantity: m.quantity,
        discount: m.discount,
        discountType: m.discountType,
        amount: m.amount,
      })),
      ...(selectedBill.packages || []).map((p) => ({
        name: p.packageName,
        providers: toProviderObjects(p.serviceProvider),
        quantity: p.quantity,
        discount: p.discount,
        discountType: p.discountType,
        amount: p.amount,
      })),
    ]
  : [];

  const handleOnExport = () => {
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(checkedClients);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'PackageBills.xlsx');
  }

  const handleDownloadBulkPdf = () => {
    if (checkedClients.length === 0) {
      setShowMessage({ message: 'No bills selected for bulk PDF download.', messageType: 'error' });
      return;
    }

    const billIds = checkedClients.map(item => item._id);

    navigate('/bulkbillgenerator', {
      state: {
        billIds,
        billType: 'Package',
      },
    });
  };


  //new code
 const getExpiryDateStyle = (dateString) => {
    if (!dateString) {
      return {};
    }
    const expiry = new Date(dateString);
    const today = new Date();
    expiry.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const baseStyle = {
      color: 'white',
      borderRadius: '12px',
      padding: '2px 8px',
      display: 'inline-block',
      fontSize: '10px',
      fontWeight: '500',
      whiteSpace: 'nowrap',
    };
    if (expiry < today) {
      return { ...baseStyle, backgroundColor: 'red' }; // Expired
    }
    return { ...baseStyle, backgroundColor: 'green' }; // Not expired
  };

  const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return 'N/A';
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

const navigate = useNavigate();

  const handleDatails = (id) => {
    navigate(`/billing/${id}`);
  };

  const openModal = () => setIsModalOpen(true);

  const closeModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    if (!activeBranchId) return;

    const loadFilters = async () => {
      const membershipRes = await fetchAllMemberships(activeBranchId);
      const packageRes = await fetchAllPackages(activeBranchId);
console.log(membershipRes,"ressssssszz")
      setMemberships(
        membershipRes.data.map((m) => ({
          value: m._id,
          label: m.membershipName,
        })),
      );

      setPackages(
        packageRes.data.map((p) => ({
          value: p._id,
          label: p.packageName,
        })),
      );
    };

    loadFilters();
  }, [activeBranchId]);


  // const handleFilterChange = (selectedValues) => {
  //    console.log(selectedValues,"valww")
  //   const genderValues = selectedValues.filter(val => 
  //     filterGenderWise.some(opt => opt.value === val)
  //   );
  //   const packageValues = selectedValues.filter(val => 
  //     packageType.some(opt => opt.value === val)
  //   );
    
  //   setGenderBy(genderValues);
  //   setSelectedByPackage(packageValues);
  //   setPage(1);
  // };
  const handleFilterChange = (selectedValues) => {
    console.log(selectedValues, "va;ue")
    console.log(genderBy,
  selectedByPackage,
  selectedMemberships,
  selectedPackages,"zzzzzz")
  const genderValues = selectedValues.filter(val =>
    filterGenderWise.some(opt => opt.value === val)
  );

  const billTypeValues = selectedValues.filter(val =>
    packageType.some(opt => opt.value === val)
  );

  const membershipValues = selectedValues.filter(val =>
    memberships.some(opt => opt.value === val)
  );

  const packageValues = selectedValues.filter(val =>
    packages.some(opt => opt.value === val)
  );

  setGenderBy(genderValues);
  setSelectedByPackage(billTypeValues);
  setSelectedMemberships(membershipValues);
  setSelectedPackages(packageValues);
  setPage(1);
};



  const handleDateRangeSelected = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    setPage(1);
    
    const queryParams = `?page=1${genderBy.length ? `&gender=${genderBy.join(',')}` : ''}${search.trim() ? `&search=${search.trim()}` : ''
      }${start ? `&startDate=${start}` : ''}${end ? `&endDate=${end}` : ''}`;
    getPackageBillsData(queryParams);
  };

  const clearDataHandler = () => {
    setLimit(10);
    setPage(1);
    setSearch('');
    setGenderBy('');
    setEndDate('');
    setStartDate('');
    setSelectedByPackage('');
    getPackageBillsData('?page=1');
    setClear(false);
  };

  // const onApplyHandler = () => {
  //   const queryParams = `?page=${page}&limit=${limit}${genderBy ? `&gender=${genderBy}` : ''}${search ? `&search=${search}` : ''
  //     }${startDate ? `&startDate=${startDate}` : ''}${endDate ? `&endDate=${endDate}` : ''}`;
  //   getPackageBillsData(queryParams);
  //   setClear(true);
  // };
  const onApplyHandler = () => {
    const queryParams =
      `?page=${page}&limit=${limit}` +
      `${genderBy.length ? `&gender=${genderBy.join(',')}` : ''}` +
      `${search.trim() ? `&search=${search.trim()}` : ''}` +
      `${startDate ? `&startDate=${startDate}` : ''}` +
      `${endDate ? `&endDate=${endDate}` : ''}` +
      `${selectedMemberships.length ? `&memberships=${selectedMemberships.join(',')}` : ''}` +
      `${selectedPackages.length ? `&packages=${selectedPackages.join(',')}` : ''}`;

    getPackageBillsData(queryParams);
    setClear(true);
  };


  useEffect(() => {
    if (activeBranchId) {
      const queryParams = `?page=1`;
      getPackageBillsData(queryParams);
      setClear(true);
    }
    return () => {
      setPackageData([]);
    };
  }, [activeBranchId]);

  // useEffect(() => {
  //   applyFilters(packagedata, limit, selectedByPackage, genderBy, page, search, startDate, endDate);
  // }, [packagedata, limit, genderBy, page, search, startDate, endDate]);
  useEffect(() => {
    applyFilters(
      packagedata,
      limit,
      selectedByPackage,
      genderBy,
      selectedMemberships,
      selectedPackages,
      page,
      search,
      startDate,
      endDate,
    );
  }, [
    packagedata,
    limit,
    genderBy,
    selectedByPackage,
    selectedMemberships,
    selectedPackages,
    page,
    search,
    startDate,
    endDate,
  ]);


  useEffect(() => {
    const totals = calculatePageTotals(filterData);
    setPackagePageTotals(totals);
  }, [filterData]);

  const calculatePageTotals = (currentPageData) => {
    const totalAmount = currentPageData.reduce((acc, item) => acc + (item.amountPayable || 0), 0);

    const amountPaid = currentPageData.reduce((acc, item) => {
      if (Array.isArray(item.amountPaid)) {
        const totalPaid = item.amountPaid.reduce((sum, payment) => sum + (parseFloat(payment.amount) || 0), 0);
        return acc + totalPaid;
      }
      return acc;
    }, 0);

    const paidDues = currentPageData.reduce((acc, item) => acc + (item.paidDues || 0), 0);

    return { totalAmount, amountPaid, paidDues: isNaN(paidDues) ? 0 : paidDues };
  };

  const getPackageBillsData = async (queryParams = '') => {
    try {
      setShowLoader(true);
      const params = queryParams || '?page=1';
      const res = await fetchPackageBills(activeBranchId, params);
      if (res.statusCode === 200) {
        setPackageData(res?.data || []);
        if (!queryParams.includes('startDate') && !queryParams.includes('endDate')) {
          setFilteredDataCount(res?.data?.length || 0);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setShowLoader(false);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  const applyFilters = (
    data,
    limit,
    selectedByPackage,
    gender,
    selectedMemberships,
    selectedPackages,
    page,
    search,
    startDate,
    endDate,
  ) => {
    let filteredData = [...data];

    filteredData = filteredData.filter((item) => {
      let isGenderMatch = true;
      let isNameMatch = true;
      let isPackageType = true;
        let isMembershipMatch = true;
        let isServicePackageMatch = true;

      if (selectedByPackage.length) {
        isPackageType = selectedByPackage.includes(item.billType);
      }

      if (gender.length) {
        isGenderMatch = genderBy.includes(item.gender);
      }
      if (selectedMemberships.length) {
        isMembershipMatch = selectedMemberships.includes(item.membershipDetails);
      }
      if (selectedPackages.length) {
        isServicePackageMatch = selectedPackages.includes(item.servicesPackage);
      }


      const searchTerm = (search || '').trim().toLowerCase();

      if (searchTerm) {
        isNameMatch =
          (item.clientName || '').toLowerCase().includes(searchTerm) ||
          String(item.clientNumber || '').includes(searchTerm);
      }

      if (startDate && endDate) {
        const itemDate = new Date(item.dateOfBilling);
        const start = new Date(startDate);
        const end = new Date(endDate);
        isNameMatch = isNameMatch && itemDate >= start && itemDate <= end;
      }

      return (
        isGenderMatch && isNameMatch && isPackageType && isMembershipMatch && isServicePackageMatch
      );
    });

    setFilteredDataCount(filteredData.length);

    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
    const paginatedData = filteredData.slice(startIndex, endIndex);

    setFilterData(paginatedData);
  };

  const handlePageChange = (e, value) => {
    setPage(value);
  };

  const handleDeleteField = (id) => {
    setDeleteId(id);
    setOpenDeleteDialog(true);
  }

  const confirmDelete = async () => {
    setDeleteLoading(true);
    try {
      const res = await deletePackagebill(deleteId, activeBranchId);
      if (res?.statusCode === 200) {
        setShowMessage({
          message: res.message || 'Bill deleted successfully',
          messageType: 'success',
        });

        setFilterData((prevData) => prevData.filter((item) => item._id !== deleteId));
      } else {
        setShowMessage({
          message: res.message || 'Bill not deleted',
          messageType: 'error',
        });
      }
    } catch (error) {
      setShowMessage({
        message: error.message || 'Something went wrong',
        messageType: 'error',
      });
    } finally {
      setOpenDeleteDialog(false);
      setDeleteId(null);
      setDeleteLoading(false);
    }
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setDeleteId(null);
  };

  const handleCheckboxChange = (e, item) => {
    if (e.target.checked) {
      setCheckedClients([...checkedClients, item]);
    } else {
      setCheckedClients(checkedClients.filter((i) => i._id !== item._id));
    }
  }

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      setCheckedClients(filterData);
      setIsAllChecked(true);
    } else {
      setCheckedClients([]);
      setIsAllChecked(false);
    }
  }
 // Grid layout for the package bills table (overrides flex-based .table-thead/.table-tbody CSS)
    const packageGridTemplate =
      '30px minmax(95px, 100px) 100px 1fr 110px 70px 130px 110px 80px 80px 80px 110px 90px 120px';

    const packageGridRowStyle = {
      display: 'grid',
      gridTemplateColumns: packageGridTemplate,
      alignItems: 'center',
      columnGap: '8px',
    };
    // Remove only leading spaces while typing (spaces between words still work)
    const handleSearchChange = (e) => {
      setSearch(e.target.value.trimStart());
      setPage(1);
    };

    // Runs when the user pastes into the search box
    const handleSearchPaste = (e) => {
      e.preventDefault();
      const pasted = e.clipboardData.getData('text').trim();

      // If it looks like a phone number, clean it (remove spaces, dashes, brackets, +91)
      const isPhoneLike = /^[+\d\s\-()]+$/.test(pasted);
      const cleaned = isPhoneLike
        ? pasted.replace(/[\s\-()]/g, '').replace(/^\+?91(?=\d{10}$)/, '')
        : pasted;

      setSearch(cleaned);
      setPage(1);
    };
return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0 0px 1.5rem 30px' }}>
        {/* Left Side: Show per page and Choose Date */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              flex: '1 1 300px',
              gap: '1rem' // Add gap for spacing
            }}
          >
            <div style={{ flex: '1 1 150px', maxWidth: '500px' }}>
              <InputLabel>Show per page</InputLabel>
              <Select
                style={{
                  borderRadius: '7px',
                  border: '0.5px solid #6174DD',
                  padding: '4px 12px',
                  background: '#FFF',
                  height: '40px',
                }}
                value={limit}
                onChange={handleLimitChange}
              >
                {[10, 20, 50].map((value) => (
                  <MenuItem key={value} value={value}>
                    {value}
                  </MenuItem>
                ))}
                 <MenuItem value={1000000}>All</MenuItem>
              </Select>
            </div>
          </div>
        </div>

        {/* Right Side: Filters, Search, and Buttons */}
          <div style={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: '0.5rem',
            flexWrap: 'wrap',
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '170px' }} onClick={() => document.getElementById('search-input').focus()}>              <InputLabel style={{ display: 'flex', flexDirection: 'column' }}>Search</InputLabel>
<div className="search-input" style={{ display: 'flex', alignItems: 'center', width: '100%', boxSizing: 'border-box' }}>
                <img src={SearchImg} alt="search icon" style={{ marginRight: '8px' }} />
                <input
                  id="search-input"
                  type="text"
                  placeholder="Search Clients..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onPaste={handleSearchPaste}
                  style={{ border: 'none', outline: 'none', flex: 1 }}
                />
                {search && (
                  <IconButton
                    onClick={() => {
                      setSearch('');
                      setClear(false);
                    }}
                    style={{ padding: 1 }}
                  >
                    <ClearIcon style={{
                      color: '#000',
                      marginRight: '0 rem', marginTop: '0.1rem',
                      fontSize: '1.1rem'
                    }} />
                  </IconButton>
                )}
              </div>
            </div>
            
            {/* --- NEW GROUPING DIV --- */}
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: '0.5rem', marginTop: '1rem' }}>
                <div style={{ width: 'auto', minWidth: '120px' }}>
                   <BigFilter
                    options={[
                      { title: 'Gender', items: filterGenderWise },
                      { title: 'Package Type', items: packageType },
                      { title: 'Memberships', items: memberships },
                      { title: 'Packages', items: packages }
                    ]}
                    value={[...genderBy, ...selectedByPackage,  ...selectedMemberships,...selectedPackages,]}
                    onChange={handleFilterChange}
                    showDateRange={true}
                    onDateRangeSelected={handleDateRangeSelected}
                    selectedStartDate={startDate}
                    selectedEndDate={endDate}
                    placeholder="Filters"
                  />
                </div>
                {
                            !hideDownloadButton && (
                              <div style={{ width: 'auto' }}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  title="Bulk Download Bill PDF"
                                  sx={{
                                    height: '40px',
                                    padding: '0.3rem 1rem',
                                    '&:hover': { background: '#6174DD' },
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                  }}
                                  onClick={handleDownloadBulkPdf}
                                >
                                        <FaDownload style={{ fontSize: '1.2rem' }} />
                                  {/* <FaFilePdf style={{ fontSize: '1.2rem' }} /> */}
                                  PDF
                                </Button>
                              </div>
                            )
                          }
                          {/* Download Button */}
                          {
                            !hideDownloadButton && (
                              <div style={{ width: 'auto' }}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  title="Download Bills"
                                  sx={{
                                    height: '40px',
                                    padding: '0.3rem 1rem',
                                    '&:hover': { background: '#6174DD' },
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                  }}
                                  onClick={handleOnExport}
                                >
                                        <FaDownload style={{ fontSize: '1.2rem' }} />
                                  {/* <FaFileExcel style={{ fontSize: '1.2rem' }} /> */}
                                  Excel
                                </Button>
                              </div>
                            )
                          }
                        </div>
                  
            
            {/* --- END NEW GROUPING DIV --- */}

          </div>
      </div>

      {showLoader ? (
        <ShowLoader />
      ) : filterData.length > 0 ? (
        <Box>
          <MuiGrid container spacing={3}>
            <MuiGrid item xs={12}>
              <Box sx={{ overflow: 'auto', width: { xs: '450px', sm: 'auto' } }}>
              <table className="table-container mt-3">
                  <thead className="table-thead">
                    <tr style={packageGridRowStyle}>
                      <th>
                        <input
                          type="checkbox"
                          checked={isAllChecked}
                          onChange={handleSelectAllChange}
                        />
                      </th>
                      {[
                        'Date of Bill',
                        'Expiry',
                        'Client Name',
                        'Contact',
                        'Gender',
                        'Membership / Package',
                        'Service Provider',
                        'Total',
                        'Paid',
                        'Pending',
                        'Mode of Payment',
                        'Bill Type',
                        'Actions',
                      ].map((h, index) => (
                        <th key={index} style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>
                          {h}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="table-tbody">
                    {filterData.map((item) => {
                      const originalDate = item?.dateOfBilling;

                      let formattedBillDate = '';
                      if (originalDate) {
                        const [year, month, day] = originalDate.split('-');
                        formattedBillDate = `${day}-${month}-${year}`;
                      }
// newcode
                      const expiryDate = item.endDate;
                      const isDueBill = item.createdBillFor === 'Due';
                    return (
                        <tr key={item._id} style={packageGridRowStyle}>
                          <td>
                            <input
                              type="checkbox"
                              checked={checkedClients.some((c) => c._id === item._id)}
                              onChange={(e) => handleCheckboxChange(e, item)}
                            />
                          </td>
                          <td style={{ whiteSpace: 'nowrap', textAlign: 'center' }}>{formattedBillDate}</td>
                           <td style={{ textAlign: 'center' }}>
                            <Box component="span" sx={getExpiryDateStyle(expiryDate)}>
                              {formatDateToDDMMYYYY(expiryDate)}
                            </Box>
                          </td>
                          <td style={{ textAlign: 'center' }}>{item?.clientName}</td>
                          <td style={{ width: '100%', textAlign: 'center' }}>
                            {maskData(item?.clientNumber, branchData?.isMasked)}
                          </td>
                          <td style={{ textAlign: 'center' }}>{item?.gender}</td>
                          <td
                            style={{
                              maxWidth: '120px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              textAlign: 'center',
                            }}
                            title={
                              item?.memberships?.length > 0
                                ? item.memberships[0].membershipName
                                : item?.packages?.length > 0
                                ? item?.packages[0]?.packageName
                                : '-'
                            }
                          >
                            {item?.memberships?.length > 0
                              ? item.memberships[0].membershipName
                              : item?.packages?.length > 0
                              ? item?.packages[0]?.packageName
                              : '-'}
                          </td>
                          <td style={{textAlign: 'center'  }}>
                            {item.serviceProviderName ? item?.serviceProviderName : '-'}
                          </td>
                          <td style={{ textAlign: 'center'  }}>{item?.amountPayable}</td>
                          <td style={{ textAlign: 'center'  }}>
                            {item?.amountPaid?.reduce(
                              (acc, payment) => acc + (Number(payment.amount) || 0),
                              0,
                            )}
                          </td>
                          <td style={{ textAlign: 'center'  }}>{item?.paidDues || '0'}</td>
                          <td style={{textAlign: 'center'   }}>
                            {item?.amountPaid?.map(({ paymentType }) => paymentType).join(',  ')}
                          </td>
                          <td style={{ }}>{item?.billType}</td>
                          <td style={{ textAlign: 'center', paddingLeft: '8px' }}>
                            {isDueBill ? (
                              <span style={{ fontWeight: 'bold', color: '#ff4d4d' }}>Due Bill</span>
                            ) : (
                              <>
                                <IconButton
                                  onClick={() => handleDatails(item._id)}
                                  color="primary"
                                  title="View Details"
                                  style={{ padding: '4px' }}
                                >
                                  <AiOutlineInfoCircle
                                    style={{ color: '#696969', fontSize: '1.1rem' }}
                                  />
                                </IconButton>
                                {(item?.billType === 'Membership' || item?.billType === 'Package') && (                                  <IconButton
                                    onClick={() => handleOpenUpdate(item)}
                                    color="secondary"
                                    title="Update"
                                    style={{ padding: '4px' }}
                                  >
                                    <FaRegEdit style={{ color: '#696969', fontSize: '1rem' }} />
                                  </IconButton>
                                )}

                                <IconButton
                                  onClick={() => handleDeleteField(item._id)}
                                  color="error"
                                  title="Delete"
                                  style={{ padding: '4px' }}
                                >
                                  <MdDelete color="#FF4D4D" style={{ fontSize: '1.2rem' }} />
                                </IconButton>
                              </>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
                  <DialogContent>
                    Are you sure you want to delete this Bill?
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseDeleteDialog} color="primary">Cancel</Button>
                    <Button onClick={confirmDelete} color="secondary" disabled={deleteLoading}>Delete</Button>
                  </DialogActions>
                </Dialog>
               <Dialog
                  open={openUpdateDialog}
                  onClose={handleCloseUpdate}
                  PaperProps={{
                    style: {
                      maxWidth: '1200px',
                      width: '90%',
                      minHeight: '80%',
                    },
                  }}
                >
                  <DialogContent>
                    <div>
                      <div className="mb-3">
                        <form className="row">
                          <div className="col-md-3 text-start">
                            <label className="form-label">Date of Billing</label>
                            <input
                              type="date"
                              max={new Date().toISOString().split('T')[0]}
                              className="form-control"
                              value={updateFormData?.dateOfBilling || ''}
                              name="dateOfBilling"
                              onChange={handleUpdateInputChange}
                            />
                          </div>
                          <div className="col-md-3 text-start">
                            <label className="form-label">Contact Number</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="client Number"
                              value={selectedBill?.clientNumber || ''}
                              name="clientNumber"
                              disabled
                            />
                          </div>
                          <div className="col-md-3 text-start">
                            <label className="form-label">Client Name</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="client name"
                              value={selectedBill?.clientName || ''}
                              name="clientName"
                              disabled
                            />
                          </div>
                          <div className="col-md-3 text-start">
                            <label className="form-label">Time of Billing</label>
                            <input
                              type="time"
                              className="form-control"
                              value={updateFormData?.timeOfBilling || ''}
                              name="timeOfBilling"
                              onChange={handleUpdateInputChange}
                            />
                          </div>
                          <div className="col-md-3 text-start">
                            <label className="form-label">Service For</label>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              name="gender"
                              value={selectedBill?.gender || ''}
                              disabled
                            >
                              <option value="" disabled>
                                --select gender--
                              </option>
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                            </select>
                          </div>
                        </form>
                      </div>

                      <div className="table-responsive responsive_tbl">
                        <table className="table table-bordered">
                          <thead>
                            <tr className="list">
                              <th className="col-md-3">Service / Products / Packages</th>
                              <th className="col-md-2">Service provider</th>
                              <th className="col-md-1">Qty</th>
                              <th className="col-sm-2">Discount</th>
                              <th className="col-md-2">Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {billItems.map(
                              (item, index) =>
                                item.name && (
                                  <tr key={index}>
                                    <td className="col-md-3">
                                      <div className="d-flex grid gap-2 align-items-center col-md-12">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Service"
                                          value={item.name}
                                          disabled
                                        />
                                      </div>
                                    </td>
                                    <td className="col-md-2">
                                      <Autocomplete
                                        multiple
                                        disabled
                                        options={serviceProviders}
                                        value={item.providers || []}
                                        getOptionLabel={(o) => o.name}
                                        isOptionEqualToValue={(opt, val) => opt._id === val._id}
                                        renderInput={(params) => (
                                          <TextField {...params} label="Service Providers" size="small" />
                                        )}
                                        sx={{
                                          width: 250,
                                          '& .MuiAutocomplete-listbox': { maxHeight: 120 },
                                        }}
                                        ListboxProps={{ style: { maxHeight: 120, overflowY: 'auto' } }}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        type="number"
                                        min={1}
                                        className="form-control ser_cat"
                                        placeholder="Qty"
                                        value={item.quantity ?? ''}
                                        disabled
                                      />
                                    </td>
                                    <td className="col-sm-2">
                                      <div className="col-md-12 d-flex grid gap-2 align-items-center">
                                        <input
                                          type="number"
                                          className="form-control ser_cat"
                                          min={0}
                                          placeholder="0"
                                          value={item.discount ?? ''}
                                          disabled
                                        />
                                        <select
                                          className="form-select"
                                          aria-label="Default select example"
                                          value={item.discountType || '%'}
                                          disabled
                                        >
                                          <option value="%">%</option>
                                          <option value="INR">INR</option>
                                        </select>
                                      </div>
                                    </td>
                                    <td className="col-md-2">
                                      <input
                                        type="number"
                                        min={0}
                                        className="form-control ser_cat"
                                        placeholder="amount"
                                        value={item.amount ?? ''}
                                        disabled
                                      />
                                    </td>
                                  </tr>
                                ),
                            )}
                          </tbody>
                        </table>

                        <table className="table table-bordered">
                          <tbody>
                            <tr>
                              <td>Subtotal</td>
                              <td className="col-md-2" style={{ textAlign: 'center' }}>
                                <span>INR&nbsp;&nbsp;{selectedBill?.subTotal}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Membership</td>
                              <td className="col-md-2" style={{ textAlign: 'center' }}>
                                {selectedBill?.useMembership && <span style={{ color: 'green' }}>Applied</span>}
                              </td>
                            </tr>
                            <tr>
                              <td>Taxes</td>
                              <td className="col-md-4">
                                <select className="form-select" disabled value="current">
                                  <option value="current">
                                    {(() => {
                                      const taxes = selectedBill?.taxes;
                                      const type = taxes?.taxType;
                                      const subTotal = Number(selectedBill?.subTotal || 0);
                                      const totalAmount = Number(selectedBill?.totalAmount || 0);

                                      if (type === 'Exclusive') return 'Exclusive';
                                      if (type === 'Inclusive' || type === 'Ingst') return 'Inclusive';

                                      if (totalAmount > subTotal) return 'Exclusive';

                                      if (totalAmount === subTotal && totalAmount > 0) {
                                        const totalLineAmount = billItems.reduce(
                                          (acc, item) => acc + Number(item.amount || 0),
                                          0,
                                        );
                                        if (Math.abs(subTotal - totalLineAmount) < 1) return 'No GST';
                                        return 'Inclusive';
                                      }
                                      return 'No GST';
                                    })()}
                                  </option>
                                </select>
                              </td>
                            </tr>
                            <tr>
                              <td>Discount</td>
                              <td className="col-md-2">
                                <div className="col-md-12 d-flex grid gap-2 align-items-center">
                                  <input
                                    type="number"
                                    className="form-control ser_cat"
                                    min={0}
                                    placeholder="0"
                                    value={selectedBill?.discount?.discount ?? ''}
                                    disabled
                                  />
                                  <select
                                    className="form-select"
                                    aria-label="Default select example"
                                    value={selectedBill?.discount?.discountType || '%'}
                                    disabled
                                  >
                                    <option value="%">%</option>
                                    <option value="INR">INR</option>
                                  </select>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td> Total</td>
                              <td className="col-md-2" style={{ textAlign: 'center' }}>
                                <span>INR&nbsp;&nbsp;{selectedBill?.totalAmount}</span>
                              </td>
                            </tr>
                            <tr>
                              <td> Coupon</td>
                              <td className="col-md-2" style={{ textAlign: 'center' }}>
                                {selectedBill?.coupon?.couponId && <span>{selectedBill?.coupon?.couponCode} </span>}
                              </td>
                            </tr>
                            <tr>
                              <td>Current Amount</td>
                              <td className="col-md-2" style={{ textAlign: 'center' }}>
                                <span>&nbsp;&nbsp;{selectedBill?.amountPayable}</span>
                              </td>
                            </tr>
                            <tr>
                              <td style={{ fontWeight: 'bold' }}>Net Amount</td>
                              <td className="col-md-2" style={{ textAlign: 'center' }}>
                                <span style={{ fontWeight: 'bold' }}>&nbsp;&nbsp;{selectedBill?.amountPayable}</span>
                              </td>
                            </tr>
                            <tr>
                              <td> Amount paid</td>
                              <td className="col-md-4" colSpan="2">
                                {updateFormData?.amountPaid?.map((amountPaid, index) => (
                                  <table key={amountPaid._id || `new-${index}`}>
                                    <tbody>
                                      <tr style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <td>
                                          <input
                                            type="number"
                                            step="1"
                                            className="form-control"
                                            min="0"
                                            name="amount"
                                            placeholder="0"
                                            value={amountPaid?.amount}
                                            onChange={(e) => handlePaymentChange(e, index)}
                                          />
                                        </td>
                                        <td>
                                          <select
                                            className="form-select"
                                            aria-label="Default select example"
                                            data-validation="required"
                                            name="paymentType"
                                            value={amountPaid?.paymentType}
                                            onChange={(e) => handlePaymentChange(e, index)}
                                          >
                                            <option value="" disabled>
                                              --Select--
                                            </option>
                                            <option value="Cash">Cash</option>
                                            <option value="Credit/Debit Card">Credit/Debit card</option>
                                            <option value="Paytm">Paytm</option>
                                            <option value="PhonePe">PhonePe</option>
                                            <option value="Gpay">Gpay</option>
                                          </select>
                                        </td>
                                        <td>
                                          {index === 0 ? (
                                            <span className="input-group-btn">
                                              <Button
                                                variant="contained"
                                                color="primary"
                                                sx={{
                                                  background: '#6174DD',
                                                  fontSize: '15px',
                                                  fontWeight: 'bold',
                                                }}
                                                onClick={addPaymentRow}
                                              >
                                                <span className="bi bi-plus small"></span>
                                              </Button>
                                            </span>
                                          ) : !amountPaid._id ? (
                                            <span className="input-group-btn">
                                              <Button
                                                variant="contained"
                                                color="error"
                                                sx={{
                                                  background: '#bb2d3b',
                                                  fontSize: '15px',
                                                  fontWeight: 'bold',
                                                }}
                                                onClick={() => deletePaymentRow(index)}
                                              >
                                                <span className="bi bi-dash small"></span>
                                              </Button>
                                            </span>
                                          ) : null}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                ))}
                                {!isPaidTotalMatching && (
                                  <Typography variant="caption" sx={{ color: '#d32f2f' }}>
                                    Total must be ₹{originalPaidTotal} (currently ₹{formPaidTotal})
                                  </Typography>
                                )}
                              </td>
                            </tr>
                            <tr>
                              <td>New Amount due</td>
                              <td className="col-md-2" style={{ textAlign: 'center' }}>
                                <span name="paidDues">
                                  INR&nbsp;&nbsp;
                                  {selectedBill?.paidDues || 0}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td colSpan="7">
                                <textarea
                                  className="form-control no-resize"
                                  rows="2"
                                  placeholder="Write bill update reason..."
                                  id="textArea"
                                  name="reasonForUpdate"
                                  value={updateFormData?.reasonForUpdate || ''}
                                  onChange={handleUpdateInputChange}
                                ></textarea>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </DialogContent>

                  <DialogActions>
                    {updateLoading ? (
                      <ShowLoader />
                    ) : (
                      <>
                        <div>
                          <Button
                            variant="contained"
                            fullWidth
                            color="primary"
                            sx={{ background: '#6174DD' }}
                            onClick={handleCloseUpdate}
                          >
                            Cancel
                          </Button>
                        </div>
                        <div>
                          <Button
                            variant="contained"
                            fullWidth
                            color="primary"
                            sx={{ background: '#6174DD' }}
                            onClick={handleUpdateBill}
                            disabled={!isPaidTotalMatching}
                          >
                            update
                          </Button>
                        </div>
                      </>
                    )}
                  </DialogActions>
                </Dialog>
              </Box>
            </MuiGrid>
          </MuiGrid>
        </Box>
      ) : (
        'No data found'
      )}

      <Box display="flex" justifyContent="flex-end">
        <Pagination
          count={Math.ceil(filteredDataCount / limit) || 1}
          page={page}
          color="primary"
          onChange={handlePageChange}
          // sx={{
          //   '& .MuiPaginationItem-root': {
          //     borderRadius: '4px',
          //   },
          //   '& .Mui-selected': {
          //     backgroundColor: '#6174DD',
          //     color: '#fff',
          //     '&:hover': {
          //       backgroundColor: '#4a5bc7',
          //     },
          //   },
          // }}
        />
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        style={{
          width: '100%',
          marginLeft: '0.5rem',
          marginTop: '1rem',
          padding: '1rem',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          borderRadius: '8px'
        }}
      >
        <Typography variant="h6" fontWeight="600" gutterBottom>
          Amount as per Page
        </Typography>

        <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <Typography variant="subtitle1" fontWeight="600">
            <strong>Total Amount:</strong> ₹ {packagePageTotals.totalAmount}
          </Typography>
          <Typography variant="subtitle1" fontWeight="600">
            <strong>Total Paid:</strong> ₹ {packagePageTotals.amountPaid}
          </Typography>
          <Typography variant="subtitle1" fontWeight="600">
            <strong>Total Pending:</strong> ₹ {packagePageTotals.paidDues}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default PackageAllBill;